class KitBuilderBadges extends HTMLElement {
  /** @type {string} */
  #currency = "";
  /** @type {Array<{ name: string, price: string }>} */
  #badges = [];
  /** @type {{ name: string, price: string } | null} */
  selectedBadge = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.#badges = parseJSON(this.dataset.badges, []);
    this.#currency = this.dataset.currency ?? "£";

    // Update badge price when any badge is changed
    const radioButtons = this.querySelectorAll('input[type="radio"]');

    radioButtons.forEach((radio) => {
      radio.addEventListener("change", (e) => this.#handleBadgeChange(e));
    });
  }

  disconnectedCallback() {
    const radioButtons = this.querySelectorAll('input[type="radio"]');

    radioButtons.forEach((radio) => {
      radio.removeEventListener("change", (e) => {
        this.#handleBadgeChange(e);
      });
    });
  }

  /**
   * Handles the badge change event.
   * @param {Event} e - The event.
   */
  #handleBadgeChange(e) {
    if (!(e.target instanceof HTMLInputElement)) return;
    this.#updateBadgePrice(e.target.value);

    if (e.target.checked) {
      this.#updateBadgeProperties(e.target.value);
    }
  }

  /**
   * Updates the badge price.
   * @param {string} value - The value of the badge.
   */
  #updateBadgePrice(value) {
    const badge = this.#badges.find((b) => b.name === value);
    const priceSpan = this.querySelector(".kit_badge-addon-price");
    if (!(priceSpan instanceof HTMLElement)) return;

    if (value === "none" || !badge?.price) {
      priceSpan.textContent = "";
      this.selectedBadge = null;
    } else {
      priceSpan.textContent = `+ ${this.#currency}${badge.price}`;
      // Store globally to update price in other components
      this.selectedBadge = { name: badge.name, price: badge.price };
    }
  }

  /**
   * Updates the badge properties.
   * @param {string} value - The value of the badge.
   */
  #updateBadgeProperties(value) {
    const badgeInput = document.querySelector(
      'input[name="properties[Badge]"]',
    );
    const badgePriceInput = document.querySelector(
      'input[name="properties[_badgePrice]"]',
    );
    if (
      !(badgeInput instanceof HTMLInputElement) ||
      !(badgePriceInput instanceof HTMLInputElement)
    )
      return;

    if (value === "none") {
      badgeInput.value = "None";
      badgePriceInput.value = "0";
    } else {
      const badge = this.#badges.find((b) => b.name === value);
      if (!badge) return;
      badgePriceInput.value = badge.price;
      badgeInput.value = `${badge.name} (${this.#currency}${badge.price})`;
    }
  }
}

customElements.define("kit-builder-badges", KitBuilderBadges);
